import { Injectable } from '@angular/core';


@Injectable()
export class GenericService {

  toggleButtonAnimation(btn: any) {
    if (btn.nativeElement.firstElementChild.hidden) {
      btn.nativeElement.disabled = false;
      btn.nativeElement.firstElementChild.hidden = false;
      btn.nativeElement.lastElementChild.hidden = true;

    }
    else {
      btn.nativeElement.disabled = true;
      btn.nativeElement.firstElementChild.hidden = true;
      btn.nativeElement.lastElementChild.hidden = false;

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/services/generic.service.ts